import merge from 'lodash/merge';
import pick from 'lodash/pick';

const baseModel = {
  id: undefined,
  testCenterEventId: undefined,
  irregularityType: {
    id: undefined,
    irregularityCategory: {
      id: undefined,
    },
  },
  scope: '',
  notes: '',
  startDateTime: '',
  duration: 0,
  submitPersonnel: {},
  submitDateTime: undefined,
  approvalFlag: false,
  approvalNotes: '',
  approvalPersonnel: {},
  approvalDateTime: '',
  irregularityExaminees: [],
  irregularityRooms: [],
  irregularityStages: [],
  reviewCompleteFlag: false,
  reviewDateTime: undefined,
};

export default function IrregularityModel(data) {
  return merge({}, baseModel, pick(data, Object.keys(baseModel)));
};

